import React from 'react';
import GlobalContext from './GlobalContext';

const Footer = () => {
    const pictures = GlobalContext().paths.pictures;

    return (
        <footer>
            <div className="container">
                <div className="row">
                    <div className="col-md-2">
                        <a href="/1"><img id="footer-logo" src={pictures + "bss.svg"} width="100%"></img></a>
                    </div>
                    <div id="footer-text" className="col-md-6"><strong>The #1 company for office machines and furniture for over 30 years.</strong><br />43 Redcliffe St., St. John's, Antigua & Barbuda
                         <div className="d-flex footer-additional">
                            <div className="align-self-start mr-1">
                                <img src="/images/phone.svg" height="17px"></img>
                            </div>
                            <div className="align-self-end">(268)562-4839</div>
                        </div>
                        <div className="d-flex footer-additional">
                            <div className="align-self-start mr-1">
                                <img src="/images/email.svg" height="17px"></img>
                            </div>
                            <div className="align-self-end"><a href="mailto:sales@bssantigua.com">sales@bssantigua.com</a></div>
                        </div>
                    </div>
                    <div id="footer-auth-dealers" className="col-md-4">
                        <div className="row justify-content-between">
                            <strong>Authorized Dealers for:</strong>
                            <a href="#"><img height="20px" src={pictures + "logos-06.svg"}></img></a>
                        </div>
                        <div className="row justify-content-between footer-logo-row">
                            <a href="#"><img className="footer-dealer-imgs" src={pictures + "logos-04.svg"} ></img></a><a href="#"><img src={pictures + "logos-03.svg"} height="35px"></img></a><a href="#"><img className="footer-dealer-imgs" src={pictures + "logos-02.svg"} ></img></a>
                        </div>
                        <div className="row justify-content-between footer-logo-row">
                            <a href="/static_page/navigator"><img className="footer-dealer-imgs" src={pictures + "logos-05.svg"}></img></a>
                            <a href="/static_page/navigator"><img height="20px" src={pictures + "logos-08.svg"} ></img></a>
                            <a href="/static_page/navigator"><img className="footer-dealer-imgs" src={pictures + "logos-01.svg"}></img></a>
                            <a href="/static_page/navigator"><img className="footer-dealer-imgs" src={pictures + "logos-07.svg"}></img></a>       </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;